module.exports = __webpack_public_path__ + "static/media/screen2.2c87bac2.png";